export const IMPORT_DATA_SUCCESS = "IMPORT_DATA_SUCCESS";
export const IMPORT_DATA_ERROR = "IMPORT_DATA_ERROR";
export const IMPORT_DATA_PENDING = "IMPORT_DATA_PENDING";
export const CLEAR_IMPORT_DATA_ERROR = "CLEAR_IMPORT_DATA_ERROR";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
